<template lang="pug">
.blogger-verification-page
  template(v-if="!loaded")
  template(v-else-if="sent")
    .blogger-verification-page__title(v-t="'verificationRequestSent'")
  template(v-else-if="verified")
    .blogger-verification-page__title(v-t="'verificationRequestApproved'")
  template(v-else-if="declined")
    .blogger-verification-page__title(v-t="'verificationRequestDeclined'")
  template(v-else)
    .blogger-verification-page__title(v-t="'bloggerVerificationTitle'")
    p.blogger-verification-page__p(v-t="'bloggerVerificationText1'")

    .blogger-verification-page__step(v-for="(step, index) in openedSteps" :key="step.id")
      .blogger-verification-page__step-header
        .blogger-verification-page__step-header-left
          .blogger-verification-page__step-header-title(v-t="step.title")
          .blogger-verification-page__p(v-t="step.subtitle")
        .blogger-verification-page__step-header-right(:class="{'blogger-verification-page__step-header-right--active': activeStep === index}")
          .blogger-verification-page__step-header-id {{ step.id }}
          .blogger-verification-page__step-header-point
      .blogger-verification-page__body
        template(v-if="index === 0")
          .blogger-verification-page__fields
            .blogger-verification-page__field(v-for="field in step1Fields")
              .blogger-verification-page__field-label {{ field.title }}
              .blogger-verification-page__field-input-with-icon
                img.blogger-verification-page__field-input-icon(:src="field.icon" :alt="field.title")
                input.blogger-verification-page__field-input(v-model="field.value" :placeholder="$t('buttonLink')")
        template(v-if="index === 1")
          .blogger-verification-page__stats(v-for="i in stats.length" :key="`stats_${i}`")
            .blogger-verification-page__stats-title(v-t="'menuStats'")
            .blogger-verification-page__field-input-with-label
              input.blogger-verification-page__field-input(v-model="stats[i - 1]" :placeholder="$t('buttonLink')")
              //.blogger-verification-page__field-right-label(v-t="'upload'")
              ImageUpload(v-model="stats[i - 1]")
            .blogger-verification-page__stats-title-error(v-if="isNotLink(stats[i - 1])" v-t="'wrongLinkFormat'")
            template(v-if="stats[i - 1] !== ''")
              .blogger-verification-page__stats-title(v-t="'previewScreenshot'")
              img.blogger-verification-page__stats-preview(:src="stats[i - 1]" alt='screenshot')
              button.blogger-verification-page__stats-button(v-if="i === stats.length" @click="addScreenshot")
                | + {{$t('loadMore')}}
        template(v-if="index === 2")
          .blogger-verification-page__step-header-subtitle(v-t="'yourEmailRequired'")
          .blogger-verification-page__field
            .blogger-verification-page__field-label(v-t="'emailRequired'")
            .blogger-verification-page__field-input-with-icon
              img.blogger-verification-page__field-input-icon(:src="emailIcon" alt="email")
              input.blogger-verification-page__field-input(v-model="email")
            .blogger-verification-page__stats-title-error(v-if="!emailIsOk" v-t="'wrongEmailFormat'")
          .blogger-verification-page__step-header-subtitle(v-t="'yourSocialMediaAtLastOne'")
          .blogger-verification-page__fields
            .blogger-verification-page__field(v-for="field in step3Fields")
              .blogger-verification-page__field-label {{ field.title }}
              .blogger-verification-page__field-input-with-icon
                img.blogger-verification-page__field-input-icon(:src="field.icon" :alt="field.title")
                input.blogger-verification-page__field-input(v-model="field.value" :placeholder="$t('buttonLink')")

    .blogger-verification-page__button-container
      Button.blogger-verification-page__button(is-primary @click="nextStep" :is-disabled="nextStepButtonDisabled || startSending") {{ $t(buttonText) }}
</template>

<script>
import UsersService from '@/services/UsersService'
import { mapActions } from 'vuex'
import ImageUpload from '~/components/ImageUpload/ImageUpload'

export default {
  name: 'EarnVerificationPage',

  components: { ImageUpload },

  data () {
    return {
      startSending: false,
      loaded: false,
      sent: false,
      verified: false,
      declined: false,
      steps: [
        {
          id: '01',
          title: 'bloggerVerificationStep1Title',
          subtitle: 'bloggerVerificationStep1Subtitle'
        },
        {
          id: '02',
          title: 'bloggerVerificationStep2Title',
          subtitle: 'bloggerVerificationStep2Subtitle'
        },
        {
          id: '03',
          title: 'bloggerVerificationStep3Title',
          subtitle: 'bloggerVerificationStep3Subtitle'
        }
      ],
      step1Fields: [
        {
          title: 'DISCORD',
          value: '',
          icon: 'https://cdn.gaming-goods.com/images/other/info/icons/discord.png'
        },
        {
          title: 'YOUTUBE',
          value: '',
          icon: 'https://cdn.gaming-goods.com/images/other/info/icons/youtube.png'
        },
        {
          title: 'TWITCH',
          value: '',
          icon: 'https://cdn.gaming-goods.com/images/other/info/icons/twitch.png'
        },
        {
          title: 'TIKTOK',
          value: '',
          icon: 'https://cdn.gaming-goods.com/images/other/info/icons/tiktok.png'
        },
        {
          title: 'INSTAGRAM',
          value: '',
          icon: 'https://cdn.gaming-goods.com/images/other/info/icons/instagram.png'
        }
      ],
      stats: [''],
      email: '',
      emailIcon: 'https://cdn.gaming-goods.com/images/other/info/icons/email.png',
      step3Fields: [
        {
          title: 'DISCORD',
          value: '',
          icon: 'https://cdn.gaming-goods.com/images/other/info/icons/discord.png'
        },
        {
          title: 'TELEGRAM',
          value: '',
          icon: 'https://cdn.gaming-goods.com/images/other/info/icons/telegram.png'
        },
        {
          title: 'WHATSAPP',
          value: '',
          icon: 'https://cdn.gaming-goods.com/images/other/info/icons/whatsapp.png'
        },
        {
          title: 'INSTAGRAM',
          value: '',
          icon: 'https://cdn.gaming-goods.com/images/other/info/icons/instagram.png'
        }
      ],
      activeStep: 0
    }
  },

  computed: {
    openedSteps () {
      return this.steps.slice(0, this.activeStep + 1)
    },

    buttonText () {
      return this.activeStep < 2 ? 'nextStep' : 'submitAnApplication'
    },

    emailIsOk () {
      // eslint-disable-next-line no-control-regex
      return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|\\[\x01-\x09\x0B\x0C\x0E-\x7F])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21-\x5A\x53-\x7F]|\\[\x01-\x09\x0B\x0C\x0E-\x7F])+)\])/.test(
        this.email
      )
    },

    nextStepButtonDisabled () {
      let result = false
      switch (this.activeStep) {
        case 0:
          result =
            this.step1Fields
              .map(field => field.value)
              .reduce((a, b) => a + b) === ''
          break
        case 1:
          result = this.stats[0] === '' || this.isNotLink(this.stats[0])
          break
        case 2:
          result =
            this.step1Fields
              .map(field => field.value)
              .reduce((a, b) => a + b) === '' ||
            this.email === '' ||
            !this.emailIsOk
      }
      return result
    }
  },

  mounted () {
    this.checkRequestStatus()
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    addScreenshot () {
      this.stats.push('')
    },

    isNotLink (link) {
      return (
        link !== '' &&
        link.indexOf('http://') !== 0 &&
        link.indexOf('https://') !== 0
      )
    },

    nextStep () {
      if (this.activeStep < 2) {
        this.activeStep++
      } else {
        this.sendVerificationData()
      }
    },

    checkRequestStatus () {
      UsersService.getInfluencerVerificationStas(this.$axios)
        .then((response) => {
          const verificationRequestStatus =
            response.data?.data?.verification_status
          switch (verificationRequestStatus) {
            case 'pending_verification':
              this.sent = true
              break
            case 'verified':
              this.verified = true
              break
            case 'declined':
              this.declined = true
              break
          }
        })
        .finally(() => {
          this.loaded = true
        })
    },

    checkRequestAlreadySent () {
      if (this.$cookiz.get('influencer-request')) {
        this.sent = true
      }
    },

    sendVerificationData () {
      const verificationData = {
        social_networks: {
          discord: this.step1Fields.find(item => item.title === 'DISCORD')
            ?.value,
          youtube: this.step1Fields.find(item => item.title === 'YOUTUBE')
            ?.value,
          twitch: this.step1Fields.find(item => item.title === 'TWITCH')
            ?.value,
          tiktok: this.step1Fields.find(item => item.title === 'TIKTOK')
            ?.value,
          instagram: this.step1Fields.find(item => item.title === 'INSTAGRAM')
            ?.value
        },
        statistics: this.stats.map(stat => ({
          url: stat
        })),
        contact_email: this.email,
        contact_networks: {
          discord: this.step3Fields.find(item => item.title === 'DISCORD')
            ?.value,
          telegram: this.step3Fields.find(item => item.title === 'TELEGRAM')
            ?.value,
          whatsapp: this.step3Fields.find(item => item.title === 'WHATSAPP')
            ?.value,
          instagram: this.step3Fields.find(item => item.title === 'INSTAGRAM')
            ?.value
        }
      }
      this.startSending = true
      UsersService.influencerVerificationRequest(
        this.$axios,
        verificationData
      ).then(() => {
        this.sent = true
        this.$cookiz.set('influencer-request', 'sent')
        this.showModal({
          component: 'ModalMessage',
          data: {
            title: this.$t('stepSuccess'),
            type: 'success',
            text: this.$t('verificationRequestSent')
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.blogger-verification-page {
  padding: 32px 16px;

  @media (min-width: $breakpointTablet) {
    padding: 33px 24px;
    max-width: 878px;
    margin: auto;
  }

  @media (min-width: $breakpointDesktop) {
    padding: 57px 106px;
  }

  &__title {
    margin-bottom: 24px;
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    color: $white;

    @media (min-width: $breakpointDesktop) {
      font-size: 48px;
      line-height: 58px;
    }
  }

  &__p {
    margin: 16px 0 24px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: $blue-grey10;
  }

  &__step {
    margin-bottom: 64px;

    &-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      &-title {
        margin-bottom: 24px;
        font-style: normal;
        font-weight: 700;
        font-size: 28px;
        line-height: 36px;
        color: $white;
      }

      &-subtitle {
        margin-bottom: 20px;
        margin-top: 32px;
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
        color: $white;
      }

      &-right {
        color: $blue-grey30;

        &--active {
          color: $white;
        }
      }

      &-id {
        font-weight: 500;
        font-size: 32px;
        line-height: 140%;
      }
    }
  }

  &__button {
    margin: 64px 0 24px auto;

    @media (min-width: $breakpointTablet) {
      margin: 64px 0 24px;
    }
  }

  &__fields {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 24px;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
    }
  }

  &__field {
    &-label {
      margin-bottom: 12px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 100%;
      color: $blue-grey10;
    }

    &-right-label {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $white;
    }

    &-input {
      background-color: $blue-grey60;
      color: $grey05;
      width: 100%;
      height: 48px;
      margin-right: 16px;
      border-radius: 8px;

      @media (min-width: $breakpointDesktop) {
        max-width: 552px;
      }

      &-with-icon {
        display: grid;
        grid-template-columns: 24px 1fr;
        grid-gap: 12px;
        align-items: center;
        background-color: $blue-grey60;
        border-radius: 8px;
        padding-left: 16px;
      }

      &-with-label {
        display: grid;
        grid-template-columns: 1fr 120px;
        grid-gap: 26px;
        align-items: center;
        background-color: $blue-grey60;
        border-radius: 8px;
        padding-left: 16px;
        padding-right: 24px;
      }
    }
  }

  &__stats {
    &-title {
      margin-top: 24px;
      margin-bottom: 12px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 100%;
      text-transform: uppercase;
      color: $blue-grey10;

      &-error {
        margin-top: 12px;
        margin-bottom: 12px;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 100%;
        color: $red60;
      }
    }

    &-preview {
      width: 100%;
      height: 170px;
      object-fit: cover;
      border-radius: 12px;

      @media (min-width: $breakpointTablet) {
        height: 327px;
      }

      @media (min-width: $breakpointDesktop) {
        height: 337px;
      }
    }

    &-button {
      margin: 20px 0 24px;
      padding: 0 24px;
      height: 48px;
      border-radius: 8px;
      border: 2px solid $primary60;
      color: $primary60;
      background: transparent;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      cursor: pointer;
    }
  }
}
</style>
